<template>
    <div>
      <div class="tab-box" ref="tabBox" id="tab-box">
        <div class="tabs-content">
          <button
            id="company"
            class="tabs-item"
            :class="{ 'is-active': carType.car_type === currentCarType }"
                v-for="(carType, i) in cityList"
                :key="i"
                @click="handleTab(i)"
              >
                <span>{{ carType.car_type==='C' ? '汽車' : '機車' }}</span>
            </button>
        </div>
      </div>

      <div ref="bottomDialogContent" class="bottom-dialog-content">
        <div v-if="cityList.length===0" class="empty">查無資料</div>
        <div v-if="cityList[currentCarTypeIndex] !== undefined">
          <div v-for="(city, i) in cityList[currentCarTypeIndex].city_list" :key="i" >
            <div class="">
                <div class="item">
                  <div class="text-gray2">{{ city.city_name }}</div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import { queryParkingFeeBindingCityList } from '../../api/api';
  
  export default {
    name: 'road-side-parking-city-list',
    components: {
    },
    data() {
      return {
        currentCarType: '',
        currentCarTypeIndex: 0,
        cityList: {},
      };
    },
    created() {
    },
    mounted() {
      this.getParkingFeeBindingCityList();
    },
    computed: {

    },
    methods: {
      handleTab(index) {
        this.currentCarType = this.cityList[index].car_type;
        this.currentCarTypeIndex = index;
      },
      getParkingFeeBindingCityList() {
        queryParkingFeeBindingCityList().then((res) => {
          if (res.error === undefined) {
            this.cityList = res.car_type_list;
            if (this.cityList.length > 0) {
              this.currentCarType = this.cityList[0].car_type;
            }
          }
        });
      }
    },
  };
  </script>
  <style type="text/scss" lang="scss" scoped>
  .bottom-dialog-content {
    margin-top: 8px;
  }

  .required {
    margin-top: 2pt;
    margin-bottom: 26pt;
    font-size: 12pt;
  }

  .item {
    min-height: 56px;
    padding-left: 20px;
    padding-right: 20px;
    background: white;
    
  }
  
  .item-title {
    margin: 8px 20px;  
    font-size: 14px;
  }
  
  .item .text-gray2 {
    border-bottom-color: rgba(64, 64, 64, 0.1);
    border-bottom-width: 1px;
    border-bottom-style: solid;
    line-height: 55px;
  }
   
  .empty {
    color: rgba(64, 64, 64, 0.4);
    font-size: 16px;
    margin: 24px auto;
    text-align: center;
  }
   
  
.tab-box {
  margin-top: 16px;
  display: flex;
  border-bottom-color: #40404019;
  border-width: 1px;  
  border-bottom-style: solid;
}

.tabs-content {
  flex-basis: 50%;
  align-items: center;
  display: flex;
  padding-left: 16px;
}

.tabs-content button {
  all: unset;
  cursor: pointer;
  padding: 8px;
  text-align: center;
  color: #404040c0;
  flex-grow: 1;  
}

.tabs-content button.is-active {
  border-bottom-color: rgb(0, 122, 200);
  border-width: 2px;  
  border-bottom-style: solid;
}

.tabs-content button.is-active span {
  color: rgb(0, 122, 200);
}

.tabs-content button span {
  font-size: 16px;
}

  </style>
  